export default __webpack_public_path__ + "static/medium-complexity-5dedd0ef5f3af9247b90428649d1355c.png";